import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#333",
      "fill-rule": "nonzero",
      d: "M7.792 3.496A.69.69 0 0 1 8 4q0 .295-.208.504a.69.69 0 0 1-.504.208.69.69 0 0 1-.504-.208L4.712 2.433v4.855q0 .295-.208.504A.69.69 0 0 1 4 8a.69.69 0 0 1-.504-.208.69.69 0 0 1-.208-.504V2.433L1.216 4.504a.69.69 0 0 1-.504.208.69.69 0 0 1-.504-.208A.69.69 0 0 1 0 4q0-.296.208-.504L3.496.208A.69.69 0 0 1 4 0q.295 0 .504.208z"
    }, null, -1)
  ]))]))
}
export default { render: render }